enum UserTagMappingType {
  InvitationTag = "InvitationTag",
  TrialSubscription90DayTag = "TrialSubscription90DayTag",
  TrialSubscription1YearTag = "TrialSubscription1YearTag",
  PaidSubscriptionTag = "PaidSubscriptionTag",
}

export default UserTagMappingType;
